import { Fragment, useEffect, useState } from "react";
import ContactSectionFirst from "../components/contact/ContactSectionFirst";
import { useMediaQuery } from "@mui/material";
import Head from "next/head";
import { useInView } from "react-intersection-observer";
import React from "react";

// Dynamic import

const Contact = () => {
  const [isVisible, setIsVisible] = useState(false);
  const isMobile = useMediaQuery("(max-width:786px)");

  const [ref, inView] = useInView({
    triggerOnce: true, // This means the animation will trigger only once when it comes into view
    threshold: 0.1, // Percentage of the component's visibility, adjust as needed
  });

  useEffect(() => {
    if (inView) {
      setIsVisible(true);
    }
  }, [inView]);

  function addProductJsonLd() {
    return {
      __html: `{
        "@context": "https://schema.org/",
        "@type": "Organization",
        "name": "Techcelerant",
        "url": "https://techcelerant.com/contact",
      
        "contactPoint": {
          "@type": "ContactPoint",
          "telephone": "+1-832-476-1293",
          "email": "leads@techcelerant.com",
          "contactType": "Customer Service",
  
          "areaServed": "USA",
          "availableLanguage": "English"
        },
                "address": {
        "@type": "PostalAddress",
        "streetAddress": "1 Broad Ave, Unit #4",
        "addressLocality": "Fairview",
        "addressRegion": "NJ",
        "postalCode": "07022",
        "addressCountry": "US"
      }
       
      }
    `,
    };
  }

  const SeoComponents = () => (
    <Head>
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href="https://techcelerant.com/contact" />
      <title>Contact | Techcelerant</title>
      <meta
        name="description"
        content="Don't hesitate to walk with one of our business analysts or simply call us to better understand you and your project. +1-201-308-3212 | leads@techcelerant.com "
      />
      <link rel="apple-touch-icon" href="apple-touch-icon.png" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <link rel="icon" href="/favicon.ico" />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={addProductJsonLd()}
      />
    </Head>
  );

  return (
    <Fragment>
      <SeoComponents />
              {/* <h1 className={` ${GilroyFontDark.className} max-w-[74rem] mx-auto pl-[2rem] sm:pl-[0.8rem]  sm:text-start text-white text-[24px] sm:text-[65px] pb-[2rem] `}>Contact Us</h1> */}


      <section
        style={{ "--bg-01": "black" }}
        ref={ref}
        className=" py-20 body-top-section "
      >

        <ContactSectionFirst isVisible={isVisible} isMobile={isMobile} />
      </section>

      <footer></footer>
 

    </Fragment>
  );
};

export default Contact;
